var React = require('react');

function Video (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.3125 0.666667C11.1875 0.666667 11.0625 0.708333 10.9375 0.791667L8.66667 2.22917V1C8.66667 0.458333 8.16667 0 7.58333 0H1.0625C0.479167 0 0 0.458333 0 1V7.02083C0 7.5625 0.479167 8 1.0625 8H7.58333C8.16667 8 8.66667 7.5625 8.66667 7.02083V5.79167L10.9375 7.22917C11.0625 7.3125 11.1875 7.33333 11.3125 7.33333C11.6667 7.33333 12 7.0625 12 6.6875V1.33333C12 0.9375 11.6667 0.666667 11.3125 0.666667ZM7.66667 2.83333V6.97917C7.64583 7 7.625 7 7.58333 7H1.0625C1.02083 7 1 7 1 6.97917V1.04167C1 1.02083 1.02083 1 1.0625 1H7.58333C7.625 1 7.64583 1.02083 7.66667 1.04167V2.83333ZM11 6.08333L8.66667 4.625V3.39583L11 1.9375V6.08333Z","fill":"currentColor"}));
}

Video.defaultProps = {"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none"};

module.exports = Video;

Video.default = Video;
